import React from 'react';
import styles from './ScoreReduced.module.css';

const ScoreReduced = (props) => {

    let plays = null;
    if (props.plays) plays = 'plays';

    let teamName = null;
    if (props.numberOfTeams === 4) teamName = props.team.name.substring(0, 1);
    else if (props.numberOfTeams === 3 ) teamName = props.team.name.substring(0, 2);
    else teamName = props.team.name.substring(0, 5);

    return (
        <div className={[styles.score, styles[plays]].join(' ')}>
            <div className={[styles[props.team.id], styles.teamName].join(' ')}>
                {teamName}
            </div>
            <div className={styles.teamScore}>
                {props.team.score}
            </div>
        </div>
    );
}

export default ScoreReduced;